import { useRouter } from 'next/router';

import { useConfig } from 'src/common/hooks';

export default function useGetCompanyAlternateLinks() {
  const config = useConfig();

  const router = useRouter();
  const pathWithoutBaseAndParams = router.asPath
    .replace(config.BASENAME, '')
    .split('?')[0];

  const isCompanyPage = new RegExp(
    /^\/companies(?:\/[^/]+)?\/[^/]+$|^\/company\/[^/]+\/[^/]+$/
  ).test(pathWithoutBaseAndParams);

  if (!isCompanyPage) return undefined;
  const base: string = config.CANDIDATE_BASE;
  const alternateLinksMap = {
    ['x-default']: base,
    ['id-id']: `${base}/id`,
    ['en-id']: `${base}/id/en`,
    ['vi-vn']: `${base}/vn`,
    ['en-vn']: `${base}/vn/en`,
    ['en-sg']: `${base}/sg`,
    ['en-my']: `${base}/my`,
  } as const;

  const alternateLinks = Object.entries(alternateLinksMap).map(
    ([key, value]) => {
      return {
        rel: 'alternate',
        hrefLang: key,
        href: `${value}${pathWithoutBaseAndParams}`,
        key: key,
      };
    }
  );

  return alternateLinks;
}
